import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13d69840"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-stat" }
const _hoisted_2 = { class: "stat-container" }
const _hoisted_3 = { class: "stat-container__icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_statistic = _resolveComponent("n-statistic")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
      ]),
      _createVNode(_component_n_statistic, { label: _ctx.label }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }, 8, ["label"])
    ])
  ]))
}